"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fabfitfunSharedGlobal = require("@bit/fabfitfun.shared.global.button");

var _fabfitfunSharedGlobal2 = _interopRequireDefault(_fabfitfunSharedGlobal);

var _fabfitfunSharedGlobal3 = require("@bit/fabfitfun.shared.global.image");

var _fabfitfunSharedGlobal4 = _interopRequireDefault(_fabfitfunSharedGlobal3);

var _fabfitfunSharedGlobal5 = require("@bit/fabfitfun.shared.global.text-box");

var _fabfitfunSharedGlobal6 = _interopRequireDefault(_fabfitfunSharedGlobal5);

var _fabfitfunSharedGlobal7 = require("@bit/fabfitfun.shared.global.video-player");

var _fabfitfunSharedGlobal8 = _interopRequireDefault(_fabfitfunSharedGlobal7);

var _fabfitfunMyBoxGlobal = require("@bit/fabfitfun.my-box.global.my-box-header");

var _fabfitfunMyBoxGlobal2 = _interopRequireDefault(_fabfitfunMyBoxGlobal);

var _fabfitfunSharedGlobal9 = require("@bit/fabfitfun.shared.global.layout-reader-core");

var _fabfitfunSharedGlobal10 = _interopRequireDefault(_fabfitfunSharedGlobal9);

var _fabfitfunShared = require("@bit/fabfitfun.shared.boxed-timer");

var _fabfitfunShared2 = _interopRequireDefault(_fabfitfunShared);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BoxedTimer: _fabfitfunShared2.default,
  Button: _fabfitfunSharedGlobal2.default,
  Image: _fabfitfunSharedGlobal4.default,
  MyBoxHeader: _fabfitfunMyBoxGlobal2.default,
  TextBox: _fabfitfunSharedGlobal6.default,
  VideoPlayer: _fabfitfunSharedGlobal8.default
};
/**
 * View full documentation at https://bitsrc.io/fabfitfun/shared/global/layout-reader-core
 *
 * This component takes a spec id and will load the JSON configuration of that spec
 * Optionally a sysdata object may be passed containing a callBacks array
 * @param {number} id - Id of the spec data that is being passed
 * @param {object} sysdata - Data object for passing callbacks and dynamic string
 * @param {object} specData - Data returned from the server about the spec
 */
// Legacy
// const LayoutReader = ({ id, sysdata, specData }) => (
//   <LayoutReaderCore id={id} sysdata={sysdata} specData={specData} components={components} />
// );

var LayoutReader = function LayoutReader(props) {
  return _react2.default.createElement(_fabfitfunSharedGlobal10.default, Object.assign({}, props, { components: components }));
};

exports.default = LayoutReader;


LayoutReader.propTypes = {
  // sysdata: PropTypes.shape({}),
  specData: _propTypes2.default.shape().isRequired,
  id: _propTypes2.default.number.isRequired
};

//# sourceMappingURL=LayoutReader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.layout-reader/dist/LayoutReader.js
// module id = 453
// module chunks = 0